document.addEventListener("DOMContentLoaded", function () {
  console.log("Logo Switcher JS yüklendi");

  // Sadece ekranda görünen logo elementini seç
  function getVisibleLogo() {
    const logos = document.querySelectorAll('img[class*="header-logo__image"]');
    return Array.from(logos).find(logo => {
      const style = window.getComputedStyle(logo);
      return style.display !== "none" && style.visibility !== "hidden" && logo.offsetHeight > 0;
    });
  }

  const updateLogo = () => {
    const visibleLogo = getVisibleLogo();
    if (!visibleLogo) return;

    if (window.scrollY > 10) {
      visibleLogo.src = "https://cdn.shopify.com/s/files/1/0951/7029/8138/files/CAKE_7.png";
    } else {
      visibleLogo.src = "https://cdn.shopify.com/s/files/1/0951/7029/8138/files/CAKE_8.png";
    }
  };

  // Sayfa yüklendiğinde bir kere çalıştır
  updateLogo();

  // Scroll olunca tekrar çalıştır
  window.addEventListener("scroll", updateLogo);
});
